import { FleekError } from './FleekError';

type Secret = {
  id?: string;
  groupId?: string;
  key?: string;
};

type SecretFailToEncryptErrorOptions = {
  secret: Secret;
};

export class SecretFailToEncryptError extends FleekError<SecretFailToEncryptErrorOptions> {
  public name = 'SecretFailToEncryptError';

  toString = () => {
    return 'Failed to encrypt secret.';
  };
}
